var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener, FocusEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class ColorInputAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /**
         * Event called when component is closed
         */
        this.onBlur = new FocusEventListener();
        /**
         * Event called when component has changed value
         */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Returns if the color input is enabled
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the color input is enabled
     *
     * @param enabled - If the color input is enabled
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns the selected color
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Updates the selected color
     *
     * @param value - The color value
     */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Returns component state is read-only
     */
    isReadOnly() {
        return this.state.readOnly;
    }
    /**
     * Updates component state to read-only
     * @param readOnly
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ColorInputAPI.prototype, "onBlur", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ColorInputAPI.prototype, "onChange", void 0);
export { ColorInputAPI, };
//# sourceMappingURL=color-input-api.js.map